import { isPathSameAsRoute } from '@sky-distribution/gp-onboarding-shared-utils';
import { Guard } from 'xstate';
import { AppStateMachineContext, AppStateMachineEvent } from '../types';

export const isPath = (
  path: string,
  cond: Guard<AppStateMachineContext, AppStateMachineEvent>,
) => {
  if ('params' in cond && 'path' in cond.params) {
    return isPathSameAsRoute(path, cond.params.path);
  }

  return false;
};
